import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EduAuthContext = createContext(null);

export function EduAuthProvider({ children }) {
  // null = loading, false = not authenticated, object = authenticated
  const [eduUser, setEduUser] = useState(null);

  useEffect(() => {
    // Accept token passed via URL param (cross-subdomain handoff from funnel page)
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get('token');
    if (urlToken) {
      localStorage.setItem('edu_token', urlToken);
      // Clean token from URL without triggering a reload
      const clean = window.location.pathname + window.location.hash;
      window.history.replaceState({}, '', clean);
    }

    const token = urlToken || localStorage.getItem('edu_token');
    if (!token) {
      setEduUser(false);
      return;
    }
    axios
      .get(`${BACKEND_URL}/api/funnel/session`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(({ data }) => {
        setEduUser({ email: data.email, token });
      })
      .catch(() => {
        localStorage.removeItem('edu_token');
        setEduUser(false);
      });
  }, []);

  const eduLogin = (token, email) => {
    localStorage.setItem('edu_token', token);
    setEduUser({ email, token });
  };

  const eduLogout = () => {
    localStorage.removeItem('edu_token');
    setEduUser(false);
  };

  return (
    <EduAuthContext.Provider value={{ eduUser, eduLogin, eduLogout }}>
      {children}
    </EduAuthContext.Provider>
  );
}

export function useEduAuth() {
  return useContext(EduAuthContext);
}
